export const APPROVAL_TABS = {
  BILLS: { value: "bills", label: "Bills" },
  ATTENDANCE: { value: "attendance", label: "Attendance" },
  TASKS: { value: "tasks", label: "Tasks" },
};


export const APPROVAL_BILL_COLUMNS = [
  "project",
  "site",
  "category",
  "date",
  "amount",
  "status",
  "actions",
];

export const APPROVAL_BILL_LABELS = {
  project: "Project",
  site: "Site",
  category: "Type",
  date: "Date",
  amount: "Amount (₹)",
  status: "Status",
  actions: "Actions",
};

export const APPROVAL_ATTENDANCE_COLUMNS = [
  "project",
  "site",
  "date",
  "checkin_time",
  "checkout_time",
  "status",
  "actions",
];

export const APPROVAL_ATTENDANCE_LABELS = {
  project: "Project",
  site: "Site",
  date: "Date",
  checkin_time: "Check-In",
  checkout_time: "Check-Out",
  status: "Status",
  actions: "Actions",
};


export const TASK_COLUMNS = [
  "project_name",
  "site_name",
  "title",
  "type",
  "status",
  "actions",
];

export const TASK_LABELS = {
  project_name: "Project",
  site_name: "Site",
  title: "Task Title",
  type: "Type", 
  status: "Status",
  actions: "Actions",
};

export const TOAST_MESSAGES = {
  APPROVAL_SUCCESS: "Approval action completed successfully.",
  FETCH_APPROVALS_FAILED: "Failed to fetch Approvals",
  SITES_FETCH_FAILED: "Failed to load sites",
  FETCH_ERROR: "Error fetching data. Please try again later.",
  NO_DATA: "No data available.",
};

